export default {
  'Add Cut': 'Kesim Ekle',
}